export const PROJECTION_HIGHER_IS_BETTER_KEYS: readonly string[] = [
  'is.net_product_sales',
  'is.gross_product_sales',
  'is.net_revenue',
  'is.gross_profit',
  'is.gross_margin_pct',
  'is.operating_margin_pct',
  'is.net_margin_pct',
  'is.ebitdar',
  'is.ebitdar_margin_pct',
  'is.ebitda',
  'is.ebitda_margin_pct',
  'is.operating_income',
  'is.net_income_loss',
  'bs.total_cash_and_equivalents',
  'bs.cash_bank_accounts_and_petty_cash',
  'bs.cash_equivalents',
]

const HIGHER_IS_BETTER = new Set<string>(PROJECTION_HIGHER_IS_BETTER_KEYS)

export function isFavorable(lineKey: string, delta: number | null): boolean | null {
  if (delta === null) {
    return null
  }
  if (HIGHER_IS_BETTER.has(lineKey)) {
    return delta > 0
  }
  if (lineKey.startsWith('bs.') || lineKey.startsWith('cf.')) {
    return null
  }
  if (lineKey.startsWith('is.')) {
    return delta < 0
  }
  return null
}
